export default __webpack_public_path__ + "static/media/tv.a5ad1f0b.jpg";